import { IOemPageParams, IOemPage, IOemAddParams, IOemDomain, IOemBrand, IOemSmsAdd, IOemSmsAddParams, IOemAgentOptionsItem } from '../../types/oem';
import { EAxiosResponseCode, ESystemType, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * oem-oem列表
 */
export async function queryOemPageList(param: IOemPageParams) {
  let data = [] as IOemPage[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IOemPageParams;

  try {
    const { code, context, message } = await Http.post<{ data: IOemPage[]; total: number }>(`${hostUrl}/oem/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IOemPage[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * oem - oem启用/禁用
 */
export async function changeOemStatusEnable(prams) {
  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/oem/status`, prams);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * oem-oem列表-新增代理商oem
 */
export async function addOem(param: IOemAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IOemAddParams;

  try {
    const { code, message } = await Http.post<IOemAddParams>(`${hostUrl}/oem`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * oem-oem列表-修改oem有效期
 */
export async function editOemValidity(param) {

  param = JSON.parse(JSON.stringify(param));

  try {
    const { code, message } = await Http.put<IOemAddParams>(`${hostUrl}/oem/validity`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * oem-oem列表-可新增的oem代理商
 */
export async function queryOemAgentList(params: { configured: number; sysType?: ESystemType }) {
  let data = [] as IOemAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.get<IOemAgentOptionsItem[]>(
      `${hostUrl}/oem/agent/list`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * oem-oem配置-获取域名信息
 */
export async function queryOemDomainDetail(params) {
  let data = {} as IOemDomain;

  try {
    const { code, context, message } = await Http.post<IOemDomain>(
      `${hostUrl}/oem/config/dn/detail`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IOemDomain;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * oem-oem配置-配置域名
 */
export async function configemDomain(params) {

  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/oem/config/dn`,
      params,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * oem-oem配置-获取品牌配置
 */
export async function queryOemBrandDetail(params) {
  let data = {} as IOemBrand;

  try {
    const { code, context, message } = await Http.post<IOemBrand>(
      `${hostUrl}/oem/config/brand/detail`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IOemBrand;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return { data };
}

/**
 * oem-oem配置-配置品牌
 */
export async function configeOemBrand(params) {

  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/oem/config/brand`,
      params,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * oem-oem配置-获取短签配置
 */
export async function queryOemSmsDetail(params) {
  let data = {} as IOemSmsAdd;

  try {
    const { code, context, message } = await Http.post<IOemSmsAdd>(
      `${hostUrl}/oem/sms/info`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IOemSmsAdd;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return { data };
}

/**
 * oem-oem配置-短签配置
 */
export async function configeOemSms(params: IOemSmsAddParams) {

  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/oem/sms/config`,
      params,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 *  oem-导出
 */

export async function exportOemPageList(params: IOemPageParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/oem/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}